import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/addYears/index.js';

var require$$11 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$11 as default };
